import Vconsole from 'vconsole';
let vConsole = null;
if(process.env.REACT_APP_ENV !== "production"){
  vConsole = new Vconsole()
}
export default vConsole;